module.exports = __webpack_public_path__ + "static/img/icon-step1.faf9abb5.png";